var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { GraphQLURL } from "graphql-scalars";
import { Field, Int, ObjectType } from "type-graphql";
import { Node } from "../relay.js";
import { GlobalIdScalar } from "../scalars/GlobalId.js";
import { TimestampedResource } from "./Resource.js";
let ImageNode = class ImageNode extends TimestampedResource {
    id;
    url;
    mimeType;
    thumbHash;
    alt;
    width;
    height;
    getUniqueId() {
        return this.id.id;
    }
    text() {
        return this.alt || this.url?.toString() || this.id.id;
    }
    static init(init) {
        return this.createInstance().withValues(init);
    }
};
__decorate([
    Field(() => GlobalIdScalar),
    __metadata("design:type", Object)
], ImageNode.prototype, "id", void 0);
__decorate([
    Field(() => GraphQLURL, { nullable: true }),
    __metadata("design:type", Object)
], ImageNode.prototype, "url", void 0);
__decorate([
    Field(() => String, { nullable: false }),
    __metadata("design:type", String)
], ImageNode.prototype, "mimeType", void 0);
__decorate([
    Field(() => String, { nullable: true }),
    __metadata("design:type", Object)
], ImageNode.prototype, "thumbHash", void 0);
__decorate([
    Field(() => String, { nullable: true }),
    __metadata("design:type", Object)
], ImageNode.prototype, "alt", void 0);
__decorate([
    Field(() => Int, { nullable: false }),
    __metadata("design:type", Number)
], ImageNode.prototype, "width", void 0);
__decorate([
    Field(() => Int, { nullable: false }),
    __metadata("design:type", Number)
], ImageNode.prototype, "height", void 0);
__decorate([
    Field(() => String, { nullable: false }),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", String)
], ImageNode.prototype, "text", null);
ImageNode = __decorate([
    ObjectType({
        implements: [Node],
    })
], ImageNode);
export { ImageNode };
//# sourceMappingURL=Image.js.map